import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import { hapticTap } from "@/tg/init";

interface BackBarProps {
  label?: string;
  to?: string;
}

export default function BackBar({ label, to }: BackBarProps) {
  const navigate = useNavigate();
  const { t } = useI18n();

  function handleBack() {
    hapticTap();
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  }

  return (
    <button
      onClick={handleBack}
      className="flex items-center gap-1 px-4 py-3 text-sm font-medium"
      style={{ color: "var(--brand-blue)", background: "none", border: "none", cursor: "pointer" }}
    >
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true">
        <path d="M7 1L1 7L7 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {label ?? t("back")}
    </button>
  );
}
